import styles from './Recipes.module.css'
import Header from './components/Header.js';
import Loader from './components/Loader.js';
import { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import background from './assets/img/background.png';
import unknown_meal from './assets/img/unknown_meal.png'

export default function Recipes() {
    //Объект для работы с URL
    const location = useLocation();
    //Флаг загрузки
    const [loading, setLoading] = useState(false);
    //Получаемые с бэкенда параметры
    const [quantity] = useState(6);
    const [start, setStart] = useState(0);
    const [total, setTotal] = useState(70);
    const [tag] = useState(new URLSearchParams(location.search).get('tag') ? new URLSearchParams(location.search).get('tag') : '');
    const [recipes, setRecipes] = useState([]);

    //Функция получения порции рецептов
    const get_recipes = (start_position) => {
        //Устанавливаем флаг загрузки
        setLoading(true);

        //Подготавливаем адрес запроса
        let query = '/api/recipes?'
        if(tag.length)
            query += `tag=${tag}&`
        query += `start=${start_position}&`
        query += `quantity=${quantity}`

        //Осуществляем запрос
        fetch(query, {method: 'GET'})
            .then(response => response.json())
            .then(data => {
                //Сохраняем полученные данные
                if(data !== null)
                {
                    setStart(data.start);
                    setTotal(data.total);
                    setRecipes(data.recipes);
                }
                else
                    alert("Ошибка получения рецептов");

                //Сбрасываем флаг загрузки
                setLoading(false);
            })
            .catch((error) => {
                //Сбрасываем флаг загрузки
                setLoading(false);

                //Выводим информацию об ошибке
                alert("Ошибка получения рецептов");
            });
    }

    /* eslint-disable */
    //Устанавливаем позицию по странице из параметров URL и запрашиваем данные с бекенда
    useEffect(() => {
            //Получаем новую начальную позицию
            let new_start = (new URLSearchParams(location.search).get('page')) ? ((parseInt(new URLSearchParams(location.search).get('page')) - 1) * quantity) : start;
            //Если она меньше 0 или вообще не является числом, устанавливаем дефолтное значение
            if(isNaN(new_start) || new_start < 0)
                new_start = 0;

            get_recipes(new_start);
        }, [location]);

    //Устанавливаем заголовок
    useEffect(() => {
        document.title = (tag.length === 0 ? "Все рецепты" : ('Рецепты по тегу "' + tag + '"')) + " - Coperand recipes";
    }, []);
    /* eslint-enable */

    //Получаем общее количество страниц и текущую страницу
    const pages = Math.ceil(total / quantity);
    const current_page = Math.floor(start / quantity) + 1;

    return (
        <>
            {loading === true && <Loader/>}
            <div className={styles.main_column}>
                <Header/>
                <main className={styles.main} style={{backgroundImage: `url(${background})`}}>
                    {tag.length !== 0 &&
                    <h1 className={styles.main_header}>Рецепты по тегу {'"' + tag + '"'}</h1>
                    }
                    {tag.length === 0 &&
                    <h1 className={styles.main_header}>Все рецепты</h1>
                    }
                    <div className={styles.recipes_grid}>
                        {recipes.map((recipe, index) =>
                        <Link to={`/recipe?title=${recipe.title}`} className={styles.recipe_link}>
                            <div key={index} className={styles.recipe_card}>
                                <h2 className={styles.recipe_title}>{recipe.title}</h2>
                                <div className={styles.recipe_cover_background}>
                                    <img src={recipe.image.length > 0 ? '/images/' + recipe.image : unknown_meal} alt='Обложка рецепта' className={styles.recipe_cover}></img>
                                </div>
                            </div>
                        </Link>
                        )}
                    </div>
                    {pages > 0 &&
                    <div className={styles.pages}>
                        {Array.from({ length: pages }, (_, i) => i + 1).filter((page) => page === 1 || Math.abs(page - current_page) <= 1 || page === pages).map((page) =>
                        <>
                            {page === pages && current_page < (pages - 1) &&
                            <div className={styles.pages_separator}></div>
                            }
                            <Link to={tag ? `/recipes?tag=${tag}&page=${page}` : `/recipes?page=${page}`}><button className={page === current_page ? [styles.page, styles.current_page].join(' ') : styles.page}>{page}</button></Link>
                            {page === 1 && current_page > 2 &&
                            <div className={styles.pages_separator}></div>
                            }
                        </>
                        )}
                    </div>
                    }
                </main>
            </div>
        </>
    );
}
